import { CategoryFacade } from "../category/category.facade";
import { JobTypeApiFacade } from "./job-type.api-facade";
import { JobTypeStoreFacade } from "./job-type.store-facade";
import { JobType } from "./job-type.model";

export class JobTypeFacade extends CategoryFacade<JobType, JobTypeApiFacade, JobTypeStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-type/job-type.facade.ts